module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item is-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png"),
      "alt": "Cinenow"
    }
  })]), _vm._v(" "), _c('language-switch', {
    staticClass: "nav-item is-lang"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-toggle",
    class: {
      'is-active': _vm.active
    },
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: {
      'is-active': _vm.active
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c046e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 113
// module chunks = 0